/**
 * Typewriter Effect - BRONCANO
 * Efecto de escritura automática para la sección wasp-hex
 */

class TypewriterEffect {
    constructor(element, texts, options = {}) {
        this.element = element;
        this.texts = texts;
        this.options = {
            typeSpeed: options.typeSpeed || 50,
            backSpeed: options.backSpeed || 30,
            startDelay: options.startDelay || 1000,
            backDelay: options.backDelay || 2000,
            loop: options.loop !== false,
            showCursor: options.showCursor !== false,
            ...options
        };

        this.textIndex = 0;
        this.charIndex = 0;
        this.isDeleting = false;
        this.isPaused = false;
        this.timer = null;

        this.init();
    }

    init() {
        if (!this.element) return;

        if (this.options.showCursor) {
            this.element.style.position = 'relative';
        }

        this.element.textContent = '';

        this.timer = setTimeout(() => {
            this.tick();
        }, this.options.startDelay);
    }

    tick() {
        if (this.isPaused) return;

        const currentText = this.texts[this.textIndex];

        if (this.isDeleting) {
            // DELETING logic
            this.charIndex--;
            this.element.textContent = currentText.substring(0, this.charIndex);

            if (this.charIndex > 0) {
                this.timer = setTimeout(() => this.tick(), this.options.backSpeed);
            } else {
                // Done deleting
                this.isDeleting = false;
                this.textIndex = (this.textIndex + 1) % this.texts.length;

                // Stop if no loop and last item
                if (!this.options.loop && this.textIndex === 0) return;

                // Pause before typing next
                this.timer = setTimeout(() => this.tick(), 500);
            }
        } else {
            // TYPING logic
            this.charIndex++;
            this.element.textContent = currentText.substring(0, this.charIndex);

            if (this.charIndex < currentText.length) {
                this.timer = setTimeout(() => this.tick(), this.options.typeSpeed);
            } else {
                // Done typing
                if (this.texts.length > 1 && this.options.loop) {
                    this.isDeleting = true;
                    this.timer = setTimeout(() => this.tick(), this.options.backDelay);
                }
            }
        }
    }

    pause() {
        this.isPaused = true;
        if (this.timer) clearTimeout(this.timer);
    }

    resume() {
        this.isPaused = false;
        this.tick();
    }

    destroy() {
        this.isPaused = true;
        if (this.timer) clearTimeout(this.timer);
        if (this.element) {
            this.element.textContent = '';
        }
    }
}

// Inicialización del typewriter cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function () {
    initializeTypewriter();
});

// También para Turbo.js
document.addEventListener('turbo:load', function () {
    initializeTypewriter();
});

function initializeTypewriter() {
    const typewriterElement = document.getElementById('typewriter');

    if (!typewriterElement) return;

    // CLEANUP: Si ya existe una instancia previa, destrúyela para detener sus timers
    if (window.broncanoTypewriter) {
        window.broncanoTypewriter.destroy();
        window.broncanoTypewriter = null;
    }

    const texts = [
        'Tu conexión con el ecosistema aeronáutico',
        'Desde comunicaciones hasta navegación GPS',
        'Un panal de conocimiento interconectado',
        'Formación integral para el cielo del futuro'
    ];

    // Crear instancia del typewriter
    window.broncanoTypewriter = new TypewriterEffect(typewriterElement, texts, {
        typeSpeed: 60,
        backSpeed: 40,
        startDelay: 3000, // Esperar 3s después de la animación de hexágonos
        backDelay: 2500,
        loop: true,
        showCursor: true
    });
}

// Limpieza extra en navegación Turbo
document.addEventListener('turbo:before-cache', () => {
    if (window.broncanoTypewriter) {
        window.broncanoTypewriter.destroy();
    }
});

// Funcionalidad para pausar/resumir según visibilidad
function setupVisibilityControl() {
    if (!window.broncanoTypewriter) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                window.broncanoTypewriter.resume();
            } else {
                window.broncanoTypewriter.pause();
            }
        });
    }, {
        threshold: 0.5
    });

    const typewriterElement = document.getElementById('typewriter');
    if (typewriterElement) {
        observer.observe(typewriterElement.parentElement);
    }
}

// Configurar control de visibilidad después de un breve delay
setTimeout(setupVisibilityControl, 1000);